import {ApiArticle, ApiArticlePrice} from '@api/articles';
import {ArticleService} from "@iw-shop/article/services/article.service";

export class PricingModel {
    article?: ApiArticle;
    priceMode: 'net' | 'gross' = 'gross';


    price?: ApiArticlePrice;
    offerPrice?: ApiArticlePrice;

    articleQuantityPrices: ApiArticlePrice[] = [];
    cartQuantityPrices: ApiArticlePrice[] = [];

    quantityDiscountVisibilityCreationTime: number = -1;


    constructor(private articleService: ArticleService) {
    }


    setQuantityDiscountVisibility(quantityDiscountVisibility: boolean, timeout?: number) {
        if (quantityDiscountVisibility) {
            this.quantityDiscountVisibilityCreationTime = Date.now();
        } else {
            if (timeout) {
                let x = (this.quantityDiscountVisibilityCreationTime - Date.now()) / 1000;
                if (x < -timeout) {
                    this.quantityDiscountVisibilityCreationTime = -1;
                }
            } else {
                this.quantityDiscountVisibilityCreationTime = -1;
            }
        }
    }

    getNumberWithMaxFractionDigits(x: number): number {
        return x;
        /*   let value =  Number.parseFloat(String(x)).toFixed(fractionDigits);
           return parseFloat(String(value));*/
    }

    getQuantityPriceString(quantityNetPriceLessThan?: number | null, basicPrice?: {
        quantity: number,
        unit: number,
        unitOfMeasurement: string,
        taxRate: number,
        priceMode: 'net' | 'gross'
    }): string {
        let value: string = '';
        this.articleQuantityPrices.map(
            price => {
                price.netPrice = this.getNumberWithMaxFractionDigits(price.netPrice);
                if (this.offerPrice) {
                    this.offerPrice.netPrice = this.getNumberWithMaxFractionDigits(this.offerPrice.netPrice);
                }
                if (quantityNetPriceLessThan) {
                    quantityNetPriceLessThan = this.getNumberWithMaxFractionDigits(quantityNetPriceLessThan);
                }

                if (
                    (
                        !this.offerPrice ||
                        this.offerPrice.netPrice > price.netPrice
                    )
                    &&
                    (
                        !this.price ||
                        this.price.netPrice > price.netPrice
                    )
                    &&
                    (
                        !quantityNetPriceLessThan ||
                        quantityNetPriceLessThan > price.netPrice
                    )
                ) {
                    let fromQuantity: string = '';
                    if ((price.fromArticleQuantity ?? 0) > 1) {
                        fromQuantity = 'Ab dem '+price.fromArticleQuantity+'. Artikel (Rabattstaffel Artikel) ';
                    }
                    if ((price.fromCartQuantity ?? 0) > 1) {
                        fromQuantity = fromQuantity + 'Ab dem '+price.fromCartQuantity+'. Artikel im Warenkorb';
                    }
                    value = value + '<p> ' + fromQuantity+ ':  ' + this.articleService.getPrice(price.netPrice, this.article?.taxRate || 0, this.priceMode) + ' ';
                    if (basicPrice &&
                        (
                            basicPrice.unitOfMeasurement == 'l' ||
                            basicPrice.unitOfMeasurement == 'kg'
                        )
                    ) {
                        value = value + '<span class="is-size-7 is-block">';
                        if (basicPrice.unitOfMeasurement == 'l') {
                            value = value + 'Literpreis: ';
                        } else {
                            value = value + 'Kilopreis: ';
                        }
                        value = value + this.articleService.getBasicPrice(basicPrice.quantity, basicPrice.unit, price.netPrice, basicPrice.taxRate, basicPrice.priceMode) + '</span></p>'
                    } else {
                        value = value + '</p>';
                    }

                }

            }
        )

        this.cartQuantityPrices.sort((a, b) => (a.fromCartQuantity ?? 0) - (b.fromCartQuantity ?? 0));
        this.articleQuantityPrices.sort((a, b) => (a.fromArticleQuantity ?? 0) - (b.fromArticleQuantity ?? 0));
        this.cartQuantityPrices.map(
            price => {
                if (
                    (
                        !this.offerPrice ||
                        this.offerPrice.netPrice > price.netPrice
                    )
                    &&
                    (
                        !this.price ||
                        this.price.netPrice > price.netPrice
                    )
                    &&
                    (
                        !quantityNetPriceLessThan ||
                        quantityNetPriceLessThan > price.netPrice
                    )
                ) {
                    let fromQuantity: string = '';
                    if ((price.fromCartQuantity ?? 0) > 1) {
                        fromQuantity = fromQuantity + 'Ab dem '+price.fromCartQuantity+'. Artikel im Warenkorb';
                    }
                    value = value + ' ' + fromQuantity+ ': ' + this.articleService.getPrice(price.netPrice, this.article?.taxRate || 0, this.priceMode) + ' <br>';
                }
            }
        )
        return value;
    }

    setPrices(quantityNetPriceLessThan?: number | null): void {
        let i = 0, customerPrice = false;
        this.price = undefined;
        this.offerPrice = undefined;
        this.articleQuantityPrices = [];
        this.cartQuantityPrices = [];
        this.article?.bestPrices?.map(
            price => {
                price.netPrice = this.getNumberWithMaxFractionDigits(price.netPrice);
                if (quantityNetPriceLessThan) {
                    quantityNetPriceLessThan = this.getNumberWithMaxFractionDigits(quantityNetPriceLessThan);
                }
                // Mengenbezogene Artikelpreis
                if (price.fromArticleQuantity &&
                    price.fromArticleQuantity > 1 &&
                    (
                        !quantityNetPriceLessThan ||
                        quantityNetPriceLessThan > price.netPrice
                    )
                ) {
                    this.articleQuantityPrices.push(price)
                }

                // Warenkorbmenge
                if (price.fromCartQuantity &&
                    price.fromCartQuantity > 1 &&
                    (
                        !quantityNetPriceLessThan ||
                        quantityNetPriceLessThan > price.netPrice
                    )
                ) {
                    this.cartQuantityPrices.push(price)
                }

                if (i == 0 &&
                    price.customerNumber &&
                    (
                        (
                            !price.fromArticleQuantity ||
                            price.fromArticleQuantity <= 1
                        ) &&
                        (
                            !price.fromCartQuantity ||
                            price.fromCartQuantity <= 1
                        )
                    )) {
                    customerPrice = true;
                }

                // Kein Angebot und Preis ist nicht gesetzt > Auf den Übersichten sollen keine Angebotspreise ausgelesen werden
                if (!price.validFrom &&
                    !this.price &&
                    (
                        (
                            !price.fromArticleQuantity ||
                            price.fromArticleQuantity <= 1
                        ) &&
                        (
                            !price.fromCartQuantity ||
                            price.fromCartQuantity <= 1
                        )
                    )) {
                    this.price = price;

                } else if (price.validFrom &&
                    !this.offerPrice &&
                    (
                        (customerPrice && price.customerNumber) ||
                        (!customerPrice && !price.customerNumber)
                    ) &&
                    (
                        (
                            !price.fromArticleQuantity ||
                            price.fromArticleQuantity <= 1
                        ) &&
                        (
                            !price.fromCartQuantity ||
                            price.fromCartQuantity <= 1
                        )
                    )
                ) {
                    this.offerPrice = price;
                }
                i++;
            }
        );
    }
}
